import { toDate, toDateTime } from "Helpers/Format";
import { ellipsisCell, htmlEllipsisCell } from "Helpers/Table";

export const downloadColumns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Título",
    accessor: "title",
  },
  {
    Header: "Descrição",
    accessor: "description",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Níveis",
    accessor: "levels",
  },
  {
    Header: "Categoria",
    accessor: "notification_type_name",
  },
  {
    Header: "Usuário Alvo",
    accessor: (row) => row.target_user_names ?? "N/A",
  },
  {
    Header: "Criador",
    accessor: "creator_name",
  },
  {
    Header: "Automática",
    accessor: (row) => (row.automatic ? "Sim" : "Não"),
  },
  {
    Header: "Projetos",
    accessor: (row) => row.projects ?? "N/A",
  },
  {
    Header: "Usuários",
    accessor: (row) => row.target_user_ids ?? "N/A",
  },
  {
    Header: "Data de Início",
    accessor: (row) => (row.start_at ? toDate(row.start_at) : "N/A"),
  },
  {
    Header: "Data de Término",
    accessor: (row) => (row.finish_at ? toDate(row.finish_at) : "N/A"),
  },
  {
    Header: "Data de Inativação",
    accessor: (row) =>
      row.inactivated_at ? toDateTime(row.inactivated_at) : "N/A",
  },
  {
    Header: "Data de Criação",
    accessor: (row) => (row.created_at ? toDateTime(row.created_at) : ""),
  },
];

export const columns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Título",
    accessor: (row) => ellipsisCell(row.title),
  },
  {
    Header: "Descrição",
    accessor: (row) => htmlEllipsisCell(row.description),
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Níveis",
    accessor: "levels",
  },
  {
    Header: "Categoria",
    accessor: "notification_type_name",
  },
  {
    Header: "Criador",
    accessor: "creator_name",
  },
  {
    Header: "Projetos",
    accessor: (row) => row.projects ?? "N/A",
  },
  {
    Header: "Usuários",
    accessor: (row) => row.target_user_ids ?? "N/A",
  },
  {
    Header: "Automática",
    accessor: (row) => (row.automatic ? "Sim" : "Não"),
  },
  {
    Header: "Data de Início",
    accessor: (row) => (row.start_at ? toDate(row.start_at) : "N/A"),
  },
  {
    Header: "Data de Término",
    accessor: (row) => (row.finish_at ? toDate(row.finish_at) : "N/A"),
  },
  {
    Header: "Data de Inativação",
    accessor: (row) =>
      row.inactivated_at ? toDateTime(row.inactivated_at) : "N/A",
  },
  {
    Header: "Data de Criação",
    accessor: (row) => (row.created_at ? toDateTime(row.created_at) : ""),
  },
];
